module.exports = __webpack_public_path__ + "static/media/location.a2316910.svg";